<template>
  <v-card class="modal-principal">
    <v-card-title
      class="titulo"
      secondary
    >
      <span>{{titulo}}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{alerta.mensaje}}
    </v-alert>
    <v-spinner v-if="cargando"></v-spinner>
    <v-card-text
      v-else
      style="padding:0;"
    >
      <v-container class="pa-0">
        <v-layout wrap>
          <v-flex xs12>
            <v-tabs
              color="grey lighten-2"
              show-arrows
              class="elevation-0  grey lighten-2"
            >
              <v-tabs-slider color="secondary"></v-tabs-slider>

              <v-tab
                v-for="(secciones,modulo) in info.permisosAgrupados"
                :key="modulo"
                :href="'#tab-' + modulo"
                color="grey  lighten-2"
                style="font-weight: 700; color: #604492"
              >
                {{ modulo }}
              </v-tab>

              <v-tabs-items>
                <v-tab-item
                  v-for="(secciones,modulo) in info.permisosAgrupados"
                  :key="modulo"
                  :value="'tab-' + modulo"
                >
                  <v-card
                    flat
                    tile
                  >
                    <v-card-text style="max-height: 450px;padding:0;overflow-y:auto;">
                      <template v-for="(permisos,seccion) in secciones">
                        <v-subheader
                          primary
                          :key="'sh-'+seccion"
                          class="grey lighten-5 pl-2"
                        >{{seccion}}</v-subheader>
                        <v-container
                          fluid
                          grid-list-sm
                          :key="'cont-'+seccion"
                          class="py-0"
                        >
                          <v-layout
                            row
                            wrap
                          >
                            <v-flex
                              v-for="permiso in permisos"
                              :key="permiso.id"
                              xs3
                              class="pb-4"
                            >
                              <v-switch
                                v-if="esPermisoRol(permiso)"
                                :label="permiso.operacion"
                                :color="'secondary'"
                                input-value="true"
                                disabled
                                hide-details
                              ></v-switch>
                              <v-switch
                                v-else
                                v-model="itemSeleccionado.permisos_seleccionados"
                                :label="permiso.operacion"
                                :value="permiso.name"
                                :color="'primary'"
                                hide-details
                              ></v-switch>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>

          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="puedo(operacion) && !soloLectura"
        v-bind:guardando="guardando"
        v-on:alGuardar="guardar"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import abmFormularioMixin from '@/mixins/abmFormulario'
import _ from 'lodash'

export default {
  name: 'UsuariosAbmPermisos',
  mixins: [abmFormularioMixin],
  methods: {
    cargarInfo () {
      let vm = this

      let dataCombos = {
        permisosAgrupados: null
      }

      Combo.listado(dataCombos)
        .then(data => {
          vm.info = _.assign(vm.info, data)
          return vm.modeloApi.obtenerPermisos(vm.itemSeleccionado.id)
        })
        .then(data => {
          vm.itemSeleccionado = _.assign(vm.itemSeleccionado, data)
          this.cargando = false
        })
        .catch(error => {
          this.mostrarError(error)
          this.soloLectura = true
          this.cargando = false
        })
    },
    guardar () {
      let vm = this
      vm.$validator.validate().then(valid => {
        if (valid) {
          vm.ocultarAlerta()
          vm.guardando = true
          vm.modeloApi.guardarPermisos(vm.itemSeleccionado).then(
            data => {
              vm.$emit('alGuardar', data)
              vm.guardando = false
            },
            error => {
              vm.guardando = false
              vm.mostrarError(error)
            }
          )
        }
      })
    },
    esPermisoRol (item) {
      return this.itemSeleccionado.permisos_roles.indexOf(item.name) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
.v-dialog {
  box-shadow: none !important;
  max-width: 700px !important;
}

.modal-primary {
  border-radius: 20px;
  box-shadow: none !important;
}
</style>
